"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _jsxFileName = "/builds/zillow/searchxp/zillow-map-control/src/DrawSearch/DrawSearchActionBar.jsx";

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var DrawSearchActionBar =
/*#__PURE__*/
function (_PureComponent) {
  _inheritsLoose(DrawSearchActionBar, _PureComponent);

  function DrawSearchActionBar() {
    return _PureComponent.apply(this, arguments) || this;
  }

  var _proto = DrawSearchActionBar.prototype;

  _proto.render = function render() {
    return _react.default.createElement("div", {
      className: "draw-search-action-bar",
      __source: {
        fileName: _jsxFileName,
        lineNumber: 7
      },
      __self: this
    }, _react.default.createElement("div", {
      className: "draw-search-action-bar-text",
      __source: {
        fileName: _jsxFileName,
        lineNumber: 8
      },
      __self: this
    }, _react.default.createElement("div", {
      className: "draw-search-action-bar-wide-screen-text",
      __source: {
        fileName: _jsxFileName,
        lineNumber: 9
      },
      __self: this
    }, _react.default.createElement("strong", {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 10
      },
      __self: this
    }, "Draw a shape"), " around the region(s) you would like to live in"), _react.default.createElement("div", {
      className: "draw-search-action-bar-narrow-screen-text",
      __source: {
        fileName: _jsxFileName,
        lineNumber: 12
      },
      __self: this
    }, "Draw Search")), _react.default.createElement("div", {
      className: "draw-search-action-bar-spacer",
      __source: {
        fileName: _jsxFileName,
        lineNumber: 16
      },
      __self: this
    }), _react.default.createElement("button", {
      onClick: this.props.onCancel,
      className: "draw-search-action-bar-button draw-search-cancel-button",
      type: "button",
      __source: {
        fileName: _jsxFileName,
        lineNumber: 17
      },
      __self: this
    }, "Cancel"), _react.default.createElement("button", {
      onClick: this.props.onApply,
      className: "draw-search-action-bar-button draw-search-apply-button",
      type: "button",
      __source: {
        fileName: _jsxFileName,
        lineNumber: 24
      },
      __self: this
    }, "Apply"));
  };

  return DrawSearchActionBar;
}(_react.PureComponent);

exports.default = DrawSearchActionBar;
DrawSearchActionBar.propTypes = process.env.NODE_ENV !== "production" ? {
  onCancel: _propTypes.default.func,
  onApply: _propTypes.default.func
} : {};
DrawSearchActionBar.defaultProps = {
  onCancel: function onCancel() {},
  onApply: function onApply() {}
};